import { useEffect, useState } from "react";

/**
 * Interim desktop check for the Fase-2 sheets (BottomSheet's `centered` prop).
 * Fase 6 replaces this with the real DesktopShell breakpoint.
 */
export function useIsDesktopViewport(breakpoint = 900): boolean {
  const query = `(min-width: ${breakpoint}px)`;
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const listener = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mql.addEventListener("change", listener);
    return () => mql.removeEventListener("change", listener);
  }, [query]);

  return isDesktop;
}
